import { supabase } from "../../supabase.js";
import axios from "axios";
import { getOrderDeliveryState } from "./recolecciones.js";

function goBack(router, backup) {
  if (window.history.state.back === null) {
    return router.push(backup);
  }

  window.history.back();
}

export const utils = {
  goBack: goBack,
  isPendiente: isPendiente,
  requireEntregaSurtir: requireEntregaSurtir,
  getCliente: getCliente,
  getClienteProductoPrecios: getClienteProductoPrecios,
  getClienteProductos: getClienteProductos,
  getClienteProveedores: getClienteProveedores,
  getPedidosPorCliente: getPedidosPorCliente,
  getPedido: getPedido,
  getPedidoConRecoleccion: getPedidoConRecoleccion,
  getProducto: getProducto,
  updateProducto: updateProducto,
  getProductoPrecio: getProductoPrecio,
  updateProductoPrecio: updateProductoPrecio,
  getProductoPrecios: getProductoPrecios,
  getProveedor: getProveedor,
  getPedidosPorProveedor: getPedidosPorProveedor,
  authenticateAdmin: authenticateAdmin,
  authenticateProvider: authenticateProvider,
  getAuthSession: getAuthSession,
  clearAuthSession: clearAuthSession,
  getAdminPedidos: getAdminPedidos,
  getAdminInboxPedidos: getAdminInboxPedidos,
  getAdminNavCounts: getAdminNavCounts,
  getLeads: getLeads,
  updateLeadContacted: updateLeadContacted,
  updatePedido: updatePedido,
  updateManagedPedido: updateManagedPedido,
  getProductosPorProveedor: getProductosPorProveedor,
  getClienteProductosPorProveedor: getClienteProductosPorProveedor,
  createClienteProducto: createClienteProducto,
  deleteClienteProducto: deleteClienteProducto,
  deleteProductoPrecio: deleteProductoPrecio,
  uploadFile: uploadFile,
  getURL: getURL,
  deletePedidoFactura: deletePedidoFactura,
  crearPedidoFactura: crearPedidoFactura,
  getProveedores: getProveedores,
  crearProveedor: crearProveedor,
  getRecibos: getRecibos,
  getRecibo: getRecibo,
  updateRecibo: updateRecibo,
  previewReciboEnvio: previewReciboEnvio,
  updateReciboEnvio: updateReciboEnvio,
  getAllRecibos: getAllRecibos,
  crearEnvio: crearEnvio,
  updateEnvio: updateEnvio,
  getCortePreview: getCortePreview,
  crearCorte: crearCorte,
  upperCase: upperCase,
  getClientes: getClientes,
  upsertDireccion: upsertDireccion,
  getDireccion: getDireccion,
  getDirecciones: getDirecciones,
  updateProveedor: updateProveedor,
  getCatalogo: getCatalogo,
  getReciboPorMes: getReciboPorMes,
  getProveedorPricing: getProveedorPricing,
  getPricings: getPricings,
  updateCliente: updateCliente,
  getProductsById: getProductsById,
  getUniqueID: getUniqueID,
  deleteFile: deleteFile,
  getURLWrapper: getURLWrapper,
  uploadFileHandler: uploadFileHandler,
  crearRecoleccion: crearRecoleccion,
  getRecolecciones: getRecolecciones,
  getRecoleccionesRecibo: getRecoleccionesRecibo,
  actualizarEstadoRecoleccion: actualizarEstadoRecoleccion,
};

async function authenticateAdmin(passcode) {
  try {
    const response = await axios.post("/api/admin-auth", { passcode });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo autenticar al administrador"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function authenticateProvider(proveedor_id, passcode) {
  try {
    const response = await axios.post("/api/provider-auth", {
      proveedor_id,
      passcode,
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo autenticar al proveedor"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function getAuthSession(proveedor_id) {
  try {
    const response = await axios.get("/api/auth-session", {
      params: proveedor_id ? { proveedor_id } : undefined,
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo verificar la sesión"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function getLeads(contacted) {
  try {
    const response = await axios.get("/api/leads", {
      params: typeof contacted === "boolean" ? { contacted } : undefined,
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudieron cargar los leads"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function updateLeadContacted(id, contacted) {
  try {
    const response = await axios.patch("/api/leads", { id, contacted });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo actualizar el lead"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function clearAuthSession() {
  await axios.delete("/api/auth-session");
}

async function getAdminPedidos(filters = {}) {
  try {
    const response = await axios.post("/api/admin-pedidos", filters);
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudieron cargar las órdenes"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

let adminPendingPedidoIdsPromise;

function getAdminPendingPedidoIds() {
  if (!adminPendingPedidoIdsPromise) {
    adminPendingPedidoIdsPromise = supabase
      .rpc("pedidos_pendientes")
      .then(({ data, error }) => {
        if (error) throw error;
        return data || [];
      });
  }

  return adminPendingPedidoIdsPromise;
}

async function getAdminInboxPedidos() {
  const pedidoIds = await getAdminPendingPedidoIds();
  return getAdminPedidos({
    scope: "inbox",
    pedido_ids: pedidoIds,
  });
}

async function getAdminNavCounts() {
  try {
    const pedidoIds = await getAdminPendingPedidoIds();
    const response = await axios.post("/api/admin-nav-counts", {
      pedido_ids: pedidoIds,
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudieron cargar los indicadores"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function crearRecoleccion(proveedor_id, pedido_ids) {
  try {
    const response = await axios.post(
      "/api/recolecciones",
      { proveedor_id, pedido_ids }
    );
    return response.data.id;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo crear la recolección"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function getRecolecciones(estado, proveedor_id, recoleccion_id) {
  try {
    const response = await axios.get("/api/recolecciones", {
      params: {
        estado: estado || undefined,
        proveedor_id: proveedor_id || undefined,
        recoleccion_id: recoleccion_id || undefined,
      },
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudieron cargar las recolecciones"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function getRecoleccionesRecibo(reciboId, proveedorId = null) {
  try {
    const response = await axios.get("/api/recolecciones", {
      params: {
        recibo_id: reciboId,
        proveedor_id: proveedorId || undefined,
      },
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudieron cargar las recolecciones"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function actualizarEstadoRecoleccion(recoleccion_id, estado, proveedor_id) {
  try {
    await axios.patch(
      "/api/recolecciones",
      { recoleccion_id, estado, proveedor_id: proveedor_id || undefined }
    );
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo actualizar la recolección"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function deleteFile(bucket, file) {
  if (!bucket || !file) {
    console.error("Bucket or file is missing:", { bucket, file });
    return;
  }

  if (typeof file !== "string") {
    console.error("File must be a string:", file);
    return;
  }

  try {
    let files = [file];
    const { data, error } = await supabase.storage
      .from("comprobantes")
      .remove(files);

    if (error) {
      console.error("Error deleting file:", error.message);
    } else {
      console.log("DELETE SUCCESS:", data);
    }
  } catch (err) {
    console.error("Unexpected error:", err);
  }
}

async function checkID(type, id) {
  let { data, error } = await supabase.from(type).select("id").eq("id", id);

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getCliente", error);
    throw error;
  }
}

async function getCliente(cliente_id) {
  let { data, error } = await supabase
    .from("clientes")
    .select("*")
    .eq("id", cliente_id)
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getCliente", error);
    throw error;
  }
}

async function getClientes(proveedor_id) {
  let { data, error } = await supabase
    .from("cliente_proveedor")
    .select("proveedor, cliente(*)")
    .match({
      proveedor: proveedor_id,
    });

  if (data) {
    return data
      .sort((a, b) => {
        let fa = a.cliente.nombre.toLowerCase(),
          fb = b.cliente.nombre.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      })
      .map((d) => {
        return d.cliente;
      });
  } else if (error) {
    console.log("utils getClientes", error);
    throw error;
  }
}

async function getClienteProductoPrecios(cliente_id) {
  let { data, error } = await supabase
    .from("cliente_producto_precio")
    .select("producto_precio(id, producto, precio)")
    .eq("cliente", cliente_id);

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getClienteProductoPrecios", error);
    throw error;
  }
}

async function getClienteProductos(cliente_id) {
  let { data, error } = await supabase
    .from("cliente_producto")
    .select("id, producto(id, nombre, proveedor)")
    .eq("cliente", cliente_id);

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getClienteProductos", error);
    throw error;
  }
}

async function getClienteProveedores(cliente_id) {
  let { data, error } = await supabase
    .from("cliente_proveedor")
    .select(
      "activo, cliente, require_aprobacion, proveedor(id, standalone, mensaje, minimo, nombre, productos(archivado, id, nombre, precio, activo, cantidad, foto))"
    )
    .eq("activo", true)
    .eq("cliente", cliente_id);

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getClienteProveedores", error);
    throw error;
  }
}

async function getPedidosPorCliente(cliente_id) {
  let { data, error } = await supabase
    .from("pedidos")
    .select(
      "id, envios(*), cancelado, pagado, envio, proveedor (id, nombre, payments, standalone), require_factura, evidencia, require_entrega, require_aprobacion, aprobado, cliente(id), created_at, surtido, pedido_factura(*), line_items!inner(precio, cantidad, producto (id, nombre))"
    )
    .order("created_at", { ascending: false })
    .eq("cliente", cliente_id);

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getPedidosPorCliente", error);
    throw error;
  }
}

async function getPedido(pedido_id) {
  let { data, error } = await supabase
    .from("pedidos")
    .select(
      "id, envios(*), comprobantes, datos_entrega, cancelado, instrucciones, costo, envio, envio_type, distancia, pagado, proveedor (id, nombre, standalone, payments, direccion_recoleccion), require_aprobacion, require_entrega, require_factura, aprobado, cliente (*), created_at, surtido, evidencia, pedido_factura(id, url, proveedor ( nombre )), line_items!inner(id, pedido, cantidad, precio, producto (id, nombre, precio, cantidad))"
    )
    .eq("id", pedido_id)
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getPedido", error);
    throw error;
  }
}

async function getPedidoConRecoleccion(pedido_id, proveedor_id) {
  try {
    const response = await axios.get("/api/recolecciones", {
      params: {
        pedido_id,
        ...(proveedor_id ? { proveedor_id } : {}),
      },
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo cargar la orden"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function updateCliente(cliente_id, data) {
  let { error } = await supabase
    .from("clientes")
    .update(data)
    .eq("id", cliente_id);

  if (error) {
    console.log("utils updateCliente", error);
    throw error;
  } else {
    return;
  }
}

async function updateRecibo(recibo_id, data) {
  let { error } = await supabase
    .from("recibos")
    .update(data)
    .eq("id", recibo_id);

  if (error) {
    console.log("utils updateRecibo", error);
    throw error;
  } else {
    return;
  }
}

async function previewReciboEnvio(envio_id) {
  try {
    const response = await axios.post("/api/recibo-envios", { envio_id });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo recalcular el envío"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function updateReciboEnvio(envio_id, data) {
  try {
    const response = await axios.patch("/api/recibo-envios", {
      envio_id,
      data,
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo actualizar el envío"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function updatePedido(pedido_id, data) {
  if ("surtido" in data || "cancelado" in data) {
    throw new Error("Usa updateManagedPedido para surtir o cancelar una orden");
  }
  let { error } = await supabase
    .from("pedidos")
    .update(data)
    .eq("id", pedido_id);

  if (error) {
    console.log("utils updatePedido", error);
    throw error;
  } else {
    return;
  }
}

async function updateManagedPedido(pedido, data, user = "proveedor") {
  const updatesDeliveryAddress = Object.prototype.hasOwnProperty.call(
    data,
    "datos_entrega"
  );
  const updatesInventory = "surtido" in data || "cancelado" in data;
  if (pedido.proveedor?.standalone !== true && !updatesDeliveryAddress && !updatesInventory) {
    return updatePedido(pedido.id, data);
  }

  const body = { pedido_id: pedido.id, data };
  if (user === "proveedor") body.proveedor_id = pedido.proveedor.id;
  if (user === "cliente") body.cliente_id = pedido.cliente.id;

  try {
    const response = await axios.patch("/api/pedidos", body);
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo actualizar la orden"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function getProductosPorProveedor(proveedor_id) {
  let { data, error } = await supabase
    .from("productos")
    .select(
      "id, nombre, precio, activo, cantidad, foto, archivado, proveedor, producto_precio(*)"
    )
    .eq("proveedor", proveedor_id)
    .order("nombre", { ascending: false });

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getProductosPorProveedor", error);
    throw error;
  }
}

async function getPricings() {
  let { data, error } = await supabase
    .from("pricings")
    .select(
      "id, nombre, almacen, envio_base, envio_adicional, recoleccion_base, recoleccion_adicional, express_entre_semana, express_fin_de_semana"
    );

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getPricings", error);
    throw error;
  }
}

async function getCatalogo(proveedor_id) {
  let { data, error } = await supabase
    .from("proveedores")
    .select(
      "id, logo, nombre, productos(id, nombre, precio, texto, activo, archivado, cantidad, foto)"
    )
    .eq("id", proveedor_id)
    .eq("productos.activo", true)
    .eq("productos.archivado", false)
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getCatalogo", error);
    throw error;
  }
}

async function getClienteProductosPorProveedor(proveedor_id, cliente_id) {
  let { data, error } = await supabase
    .from("cliente_producto")
    .select("id, producto!inner(id, nombre, proveedor)")
    .eq("producto.proveedor", proveedor_id)
    .eq("cliente", cliente_id);

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getClienteProductosPorProveedor", error);
    throw error;
  }
}

async function deleteClienteProducto(cliente_producto) {
  const { error } = await supabase
    .from("cliente_producto")
    .delete()
    .match({ id: cliente_producto.id });

  if (error) {
    console.log("utils deleteClienteProducto", error);
    throw error;
  } else {
    return;
  }
}

async function deletePedidoFactura(pedidoFactura) {
  const { error } = await supabase
    .from("pedido_factura")
    .delete()
    .match({ id: pedidoFactura.id });

  if (error) {
    console.log("utils deletePedidoFactura", error);
    throw error;
  } else {
    return;
  }
}

async function createClienteProducto(cliente_id, producto_id) {
  let { data, error } = await supabase
    .from("cliente_producto")
    .insert([
      {
        cliente: cliente_id,
        producto: producto_id,
      },
    ])
    .select("id, producto(id, nombre)")
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils createClienteProducto", error);
    throw error;
  }
}

async function getPedidosPorProveedor(proveedor_id, includeCollections = false) {
  if (!includeCollections) {
    const { data, error } = await supabase
      .from("pedidos")
      .select(
        "id, envios(*), proveedor(id, nombre, standalone, payments), instrucciones, cancelado, envio, require_entrega, pagado, require_factura, require_aprobacion, aprobado, cliente(id, nombre, rfc, rfc_enlace), remision_firmada, created_at, surtido, pedido_factura(*), line_items!inner(cantidad, precio, producto!inner(id, nombre, precio))"
      )
      .order("created_at", { ascending: false })
      .eq("proveedor", proveedor_id);

    if (error) throw error;
    return data || [];
  }

  try {
    const response = await axios.get("/api/recolecciones", {
      params: { proveedor_id, pedidos: true },
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudieron cargar las órdenes"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function getProveedorPricing(proveedor_id) {
  let { data, error } = await supabase
    .from("proveedores")
    .select("pricing(id, envio_base, envio_adicional)")
    .eq("id", proveedor_id)
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getProveedorPricing", error);
    throw error;
  }
}

async function getProveedor(proveedor_id) {
  let { data, error } = await supabase
    .from("proveedores")
    .select(
      "id, nombre, correo, almacen, tarimas, logo, minimo, standalone, payments, direccion_recoleccion, pricing(id, nombre, almacen, envio_base, envio_adicional, recoleccion_base, recoleccion_adicional, express_entre_semana, express_fin_de_semana)"
    )
    .eq("id", proveedor_id)
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getProveedor", error);
    throw error;
  }
}

async function getProducto(producto_id) {
  let { data, error } = await supabase
    .from("productos")
    .select("id, proveedor, nombre, activo, precio, texto, foto, archivado, cantidad")
    .eq("id", producto_id)
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getProducto", error);
    throw error;
  }
}

async function getProductoPrecios(producto_id) {
  let { data, error } = await supabase
    .from("producto_precio")
    .select("id, nombre, producto!inner(id, proveedor), precio)")
    .eq("producto", producto_id);

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getProductoPrecios", error);
    throw error;
  }
}

async function getProductoPrecio(producto_precio_id) {
  let { data, error } = await supabase
    .from("producto_precio")
    .select("id, nombre, producto, precio")
    .eq("id", producto_precio_id)
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getProductoPrecios", error);
    throw error;
  }
}

async function updateProducto(producto) {
  const { data, error } = await supabase
    .from("productos")
    .upsert(producto)
    .select("id, proveedor, nombre, activo, precio, texto, foto, archivado, cantidad")
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils updateProducto", error);
    throw error;
  }
}

async function updateProductoPrecio(prouctoPrecio) {
  const { data, error } = await supabase
    .from("producto_precio")
    .upsert(prouctoPrecio)
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils updateProductoPrecio", error);
    throw error;
  }
}

async function deleteProductoPrecio(productoPrecio_id) {
  const { data, error } = await supabase
    .from("producto_precio")
    .delete()
    .match({ id: productoPrecio_id });

  if (data) {
    return data;
  } else if (error) {
    console.log("utils deleteProductoPrecio", error);
    throw error;
  }
}

async function uploadFileHandler(type, evt) {
  if (!evt.target.files || evt.target.files.length === 0) {
    throw new Error("Selecciona un archivo");
  }
  const file = evt.target.files[0];
  const fileExt = file.name.split(".").pop();
  const fileName = `${Math.random()}.${fileExt}`;
  const filePath = `${fileName}`;

  return await uploadFile(type, filePath, file);
}

async function getURLWrapper(type, file) {
  let fileOnly = file.split(`${type}/`)[1];
  return await getURL(type, fileOnly);
}

async function uploadFile(type, filePath, file) {
  let { data, error } = await supabase.storage
    .from(type)
    .upload(filePath, file);

  if (data && data.Key) {
    return data.Key;
  } else if (error) {
    console.log("utils uploadFile", error);
    throw error;
  }
}

async function getURL(type, file) {
  const { data, error } = supabase.storage.from(type).getPublicUrl(file);

  if (data && data.publicURL) {
    return data.publicURL;
  } else if (error) {
    console.log("utils getURL", error);
    throw error;
  }
}

async function crearPedidoFactura(pedido_id, proveedor_id, url) {
  let { data, error } = await supabase
    .from("pedido_factura")
    .insert([
      {
        proveedor: proveedor_id,
        pedido: pedido_id,
        url: url,
      },
    ])
    .select("id, url, proveedor(nombre)")
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils crearPedidoFactura", error);
    throw error;
  }
}

async function getProveedores() {
  let { data, error } = await supabase
    .from("proveedores")
    .select("id, nombre, tarimas, pricing(id, nombre, almacen)")
    .order("nombre", { ascending: true });

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getProveedores", error);
    throw error;
  }
}

async function getRecibos(proveedor_id) {
  let { data, error } = await supabase
    .from("recibos")
    .select("id, created_at, proveedor, mes, año, almacen, envios, extras, pago, factura")
    .eq("proveedor", proveedor_id)
    .order("created_at", { ascending: true });

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getRecibos", error);
    throw error;
  }
}

async function getReciboPorMes(mes, año, proveedor_id) {
  let { data, error } = await supabase
    .from("recibos")
    .select("id")
    .eq("proveedor", proveedor_id)
    .eq("mes", mes)
    .eq("año", año);

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getReciboPorMes", error);
    throw error;
  }
}

async function getAllRecibos() {
  let { data, error } = await supabase
    .from("recibos")
    .select(
      "id, created_at, proveedor(id, nombre), mes, año, almacen, envios, extras, pago, factura"
    )
    .order("created_at", { ascending: true })
    .order("proveedor", { ascending: true });

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getAllRecibos", error);
    throw error;
  }
}

async function getRecibo(recibo_id) {
  let { data, error } = await supabase
    .from("recibos")
    .select("id, created_at, proveedor, mes, año, almacen, envios, extras, pago, factura")
    .eq("id", recibo_id)
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getRecibo", error);
    throw error;
  }
}

async function getUniqueID(type) {
  let id;

  while (!id) {
    let idToCheck = generateRandomID();

    let existingRecord = await checkID(type, idToCheck);

    if (existingRecord.length > 0) {
      console.log("record exists", existingRecord[0]);
    } else {
      console.log("record does not exists", idToCheck);
      id = idToCheck;
      break;
    }
  }

  return id;
}

function generateRandomID() {
  let min = Math.ceil(10000);
  let max = Math.floor(99999);
  return Math.floor(Math.random() * (max - min + 1) + min);
}

async function crearProveedor(nombre) {
  let id = await getUniqueID("proveedores");

  let { data, error } = await supabase
    .from("proveedores")
    .insert([
      {
        id: id,
        nombre: nombre,
      },
    ])
    .select("id, nombre");

  if (data) {
    return data;
  } else if (error) {
    console.log("utils crearProveedor", error);
    throw error;
  }
}

async function upsertDireccion(direccion) {
  let { data, error } = await supabase
    .from("direcciones")
    .upsert([direccion])
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils upsertDireccion", error);
    throw error;
  }
}

async function getDireccion(direccion_id) {
  let { data, error } = await supabase
    .from("direcciones")
    .select("*")
    .eq("id", direccion_id)
    .single();

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getDireccion", error);
    throw error;
  }
}

async function getDirecciones(proveedor_id) {
  let { data, error } = await supabase
    .from("direcciones")
    .select("*")
    .eq("proveedor", proveedor_id);

  if (data) {
    return data;
  } else if (error) {
    console.log("utils getDirecciones", error);
    throw error;
  }
}

function isPendiente(type, pedido) {
  const deliveryPending =
    pedido.require_entrega && getOrderDeliveryState(pedido) !== "complete";

  switch (type) {
    case "admin":
      if (
        pedido.proveedor?.standalone !== true &&
        pedido.require_entrega &&
        !pedido.surtido
      ) {
        return true;
      }
      return deliveryPending;
    case "proveedor":
      if (pedido.require_aprobacion && !pedido.aprobado) {
        return true;
      } else if (
        pedido.require_factura &&
        (!pedido.pedido_factura || pedido.pedido_factura.length == 0)
      ) {
        return true;
      } else if (
        pedido.proveedor?.standalone !== true &&
        pedido.require_entrega &&
        !pedido.surtido
      ) {
        return true;
      } else if (
        pedido.require_factura &&
        !pedido.pagado &&
        pedido.proveedor.payments
      ) {
        return true;
      }
      return deliveryPending;
    case "cliente":
      if (pedido.require_aprobacion && !pedido.aprobado) {
        return true;
      } else if (
        pedido.proveedor?.standalone !== true &&
        pedido.require_entrega &&
        !pedido.surtido
      ) {
        return true;
      } else if (
        pedido.require_factura &&
        !pedido.pagado &&
        pedido.proveedor.payments
      ) {
        return true;
      }
      return deliveryPending;
  }
}

function requireEntregaSurtir(pedido) {
  if (pedido.cancelado) {
    return {
      entrega: false,
      surtir: false,
    };
  } else if (pedido.require_entrega) {
    return {
      entrega: true,
      surtir: true,
    };
  } else {
    return {
      entrega: false,
      surtir: false,
    };
  }
}

async function crearEnvio(
  pedido,
  recoleccionId = null,
  proveedorId = null
) {
  try {
    const response = await axios.post("/api/envios", {
      pedido_id: pedido.id,
      recoleccion_id: recoleccionId || undefined,
      proveedor_id: proveedorId || undefined,
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo crear el envío"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

function upperCase(str) {
  const str2 = str.charAt(0).toUpperCase() + str.slice(1);
  return str2;
}

async function updateEnvio(envio_id, data, proveedorId = null) {
  try {
    const response = await axios.patch("/api/envios", {
      envio_id,
      data,
      proveedor_id: proveedorId || undefined,
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo actualizar el envío"
    );
    apiError.status = error.response?.status;
    throw apiError;
  }
}

async function getCortePreview(proveedorId, mes, año) {
  try {
    const response = await axios.get("/api/cortes", {
      params: { proveedor_id: proveedorId, mes, año },
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo cargar el corte"
    );
    apiError.status = error.response?.status;
    apiError.recoleccionIds = error.response?.data?.recoleccion_ids || [];
    throw apiError;
  }
}

async function crearCorte(proveedorId, mes, año) {
  try {
    const response = await axios.post("/api/cortes", {
      proveedor_id: proveedorId,
      mes,
      año,
    });
    return response.data;
  } catch (error) {
    const apiError = new Error(
      error.response?.data?.error || "No se pudo crear el corte"
    );
    apiError.status = error.response?.status;
    apiError.recoleccionIds = error.response?.data?.recoleccion_ids || [];
    throw apiError;
  }
}

async function updateProveedor(proveedor_id, data) {
  let { error } = await supabase
    .from("proveedores")
    .update(data)
    .eq("id", proveedor_id);

  if (error) {
    console.log("utils updateProveedor", error);
    throw error;
  } else {
    return;
  }
}

async function getProductsById(ids) {
  const { data, error } = await supabase
    .from("productos")
    .select("id, cantidad")
    .in("id", ids);

  if (error) {
    console.log("utils getProductsById", error);
    throw error;
  } else {
    return data;
  }
}
